import {useId, type ReactNode} from 'react';

export type FormSectionProps={
  title:string;
  description?:ReactNode;
  children:ReactNode;
  className?:string;
};

export function FormSection({title,description,children,className}:FormSectionProps){
  const headingId=useId();
  return <section className={['panel','form-section',className].filter(Boolean).join(' ')} aria-labelledby={headingId}>
    <header className="form-section__header">
      <h2 id={headingId}>{title}</h2>
      {description&&<div className="form-section__description">{description}</div>}
    </header>
    <div className="form-section__content">{children}</div>
  </section>;
}
